module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_f_normal.2a072ae1.png";